import "./home.css";

import React from "react";
import Scaffold from "../commons/scaffold/scaffold";
import { HomeFeatureButton } from "./widgets/home_feature_button";

export default class HomeScreen extends React.Component {
    render() {
        return (
            <Scaffold>
                <div id="HomeScreenContainer">
                    {/* <HomeFeatureButton title="Form Pemesanan (CS)" path="/create/order"/>
                <HomeFeatureButton title="Form Pemesanan (Kasir)" path="/create/order-cashier"/>
                <HomeFeatureButton title="Form Pemesanan (BOOTH / GEROBAK)" path="/create/order-cashier?phone_required=0"/> */}
                    <HomeFeatureButton
                        title="Peta Area Layanan UENA"
                        path="/service-area"
                    />
                    <HomeFeatureButton
                        title="Completion Order Dashboard"
                        path="/completion-order"
                    />
                    <HomeFeatureButton
                        title="Dashboard Sold Out"
                        path="/dashboard_sold_out"
                    />
                    <HomeFeatureButton
                        title="Dashboard Cooking Time & Sold Out"
                        path="/sold-out-and-cooking-time"
                    />
                </div>
            </Scaffold>
        );
    }
}
